import React, { Component } from 'react';
import ReactTable from 'react-table';
import css from './react-table.css';
import { _generateCheckboxLookup, _generateTableColumns } from './table-helpers';
/////////////////////////////////////////////
/////// Custom React Table component
/////////////////////////////////////////////

export class CFTable extends React.Component {
    constructor(props){
        super(props);

        var { data, columns } = this.props;


        /////////////////////////////////////////////
        // because i'm using dummy data, delete this when controller is in place
        /////////////////////////////////////////////
        var rows = {};
        var rowIDs = [];
        var shouldLookupPersist = false;
        var normalizedData = {};

        if(columns[0].checkbox === true && data.length > 0) {
            normalizedData = _generateCheckboxLookup(data, rows, rowIDs, shouldLookupPersist);
        }

        this.state = { 
            isCheckboxEnabled: columns[0].checkbox,
            rows: normalizedData.lookup,
            rowIDs: normalizedData.idArray
        };
        /////////////////////////////////////////////
        //end temporary code
        /////////////////////////////////////////////


        // this.state = { 
        //     isCheckboxEnabled: columns[0].checkbox,
        //     rows: {},
        //     rowIDs: []
        // };


        this.setCheckboxes = this.setCheckboxes.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.resetAll = this.resetAll.bind(this);
        this.renderReactTable = this.renderReactTable.bind(this);
    }

    componentDidMount() {
        if(this.props.updateSelectedRows)
            this.props.updateSelectedRows(this.state.rows);
    }

    componentWillReceiveProps(nextProps) {
        var { data, columns } = nextProps;
        var oldData = this.props.data;
        var { rows, rowIDs } = this.state;

        var normalizedData = {};
        var equalOldData = true;

        if(oldData.length == data.length)
        {
            oldData.forEach(function(obj, index) {
                equalOldData = JSON.stringify(obj) === JSON.stringify(data[index]);
                if(!equalOldData) return;
            })
        }
        else 
            equalOldData = false;

        var shouldLookupPersist = (!(Object.keys(rows).length === 0 && rows.constructor === Object) && rowIDs.length > 0 && equalOldData)

        if(columns[0].checkbox === true && data.length > 0) {
            normalizedData = _generateCheckboxLookup(data, rows, rowIDs, shouldLookupPersist);
        }

        this.setState({ 
            rows: normalizedData.lookup,
            rowIDs: normalizedData.idArray
        });
    }

    setCheckboxes(e, rowInfo, instance) {
        var tempRows = this.state.rows;

        tempRows[rowInfo.original.ID].selected = !this.state.rows[rowInfo.original.ID].selected;

        if(tempRows.header.selected)
            tempRows.header.selected = false;

        this.setState({ rows: tempRows });

        if(this.props.updateSelectedRows)
            this.props.updateSelectedRows(tempRows);
    }

    selectAll(pageRows) {
        let { rows } = this.state;

        rows.header.selected = !rows.header.selected;

        pageRows.forEach(function(pageRow) {
            rows[pageRow._original.ID].selected = rows.header.selected;
        })

        this.setState({ rows: rows })

        if(this.props.updateSelectedRows)
            this.props.updateSelectedRows(rows);
    }

    resetAll(pageRows) {
        let { rows, rowIDs } = this.state;
        rows.header.selected = false;

        rowIDs.forEach(function(id) {
            rows[id].selected = false;
        })

        this.setState({ rows: rows });

        if(this.props.updateSelectedRows)
            this.props.updateSelectedRows(rows);
    }

    renderReactTable() {
        var { columns, filterable, sortable, data, defaultSortAsc, defaultSortAccessor } = this.props;
        var { rows, isCheckboxEnabled } = this.state;

        var _this = this;

        var dataArray = data;

        var columns = _generateTableColumns(columns, rows, data.length);

        var className = "cf-reacttable -striped -highlight " + "checkbox_" + isCheckboxEnabled + (this.props.className ? (' ' + this.props.className) : '');

        var defaultSorted = [];

        if(defaultSortAsc != null && defaultSortAccessor != null){
            defaultSorted = [
                {
                    desc: defaultSortAsc,
                    id: defaultSortAccessor
                }
            ];
        };


        if(isCheckboxEnabled) {
            return (
                <ReactTable
                    data={dataArray}
                    columns={columns}
                    className={className}
                    filterable={filterable}
                    sortable={sortable}
                    defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value}
                    showPageSizeOptions={false}
                    showPageJump={true}
                    defaultPageSize={this.props.pageSize}
                    minRows={1}
                    ref={(r) =>this.reactTable=r}
                    PaginationComponent={CustomPagination}
                    onPageChange={() => {this.resetAll()}}
                    onSortedChange={() => {this.resetAll()}}
                    defaultSorted={defaultSorted}
                    defaultFilterMethod={(filter, row, column) => 
                        {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
                        }
                    }
                    getTheadThProps={(state,rowInfo,column,instance) => 
                        {
                            return {
                                onChange: (e, handleOriginal) => {
                                    this.selectAll(state.pageRows, e.target.checked);

                                    if (handleOriginal) 
                                        handleOriginal();
                                }
                            }
                        }
                    }
                    getTdProps={(state, rowInfo, column, instance) => 
                        {
                            return {
                                onChange: (e, handleOriginal) => {
                                    if(column.checkbox === true)
                                        this.setCheckboxes(e, rowInfo, instance);

                                    if (handleOriginal)
                                        handleOriginal();
                                }
                            }
                        }
                    }
                />
            )
        }

        else {
            return (
                <ReactTable
                    data={dataArray}
                    columns={columns}
                    className={className}
                    filterable={filterable}
                    sortable={sortable}
                    ref={this.props.tableRef}
                    defaultSorted={defaultSorted}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    showPageSizeOptions={false}
                    showPageJump={true}
                    defaultPageSize={this.props.pageSize}
                    defaultFilterMethod={(filter, row, column) => 
                        {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
                        }
                    }
                    minRows={1}
                    PaginationComponent={CustomPagination}
                />
            )
        }
    }

    render() {
        var table = this.renderReactTable();

        return (
            <div className='field_row'>
                { table }
            </div>
        );
    }
};


/////////////////////////////////////////////
/////// Custom pagination component
/////////////////////////////////////////////

const spanButton = props =>
    <span {...props} className='-btn'>
        {props.children}
    </span>

export class CustomPagination extends Component {
    constructor (props) {
        super()

        this.getSafePage = this.getSafePage.bind(this)
        this.changePage = this.changePage.bind(this)
        this.applyPage = this.applyPage.bind(this)
        this.getPageEnd = this.getPageEnd.bind(this)

        this.state = {
            page: props.page,
        }
    }

    componentWillReceiveProps (nextProps) {
        this.setState({ page: nextProps.page })
    }

    getSafePage (page) {
        if (isNaN(page)) {
            page = this.props.page
        }
        return Math.min(Math.max(page, 0), this.props.pages - 1)
    }

    changePage (page) {
        page = this.getSafePage(page)
        this.setState({ page })
        if (this.props.page !== page) {
            this.props.onPageChange(page)
        }
    }

    applyPage (e) {
        e && e.preventDefault()
        const page = this.state.page
        this.changePage(page === '' ? this.props.page : page)
    }

    getPageEnd (startRow, totalRows) {
        let { pageSize, data } = this.props;

        var endRow = startRow + pageSize - 1;

        if(endRow > totalRows)
            return (startRow + (totalRows % pageSize)) - 1;
        else
            return endRow;
    }

    render () {
        const {
            // Computed
            pages,
            // Props
            page,
            showPageSizeOptions,
            pageSizeOptions,
            pageSize,
            showPageJump,
            canPrevious,
            canNext,
            onPageSizeChange,
            className,
            PreviousComponent = spanButton,
            NextComponent = spanButton,
            sortedData,
            totalRecords
        } = this.props

        var startRow = 0;
        var totalRows = 0;
        var endRow = 0;

        if(typeof totalRecords != 'undefined' && sortedData.length > 0) {
            startRow = pageSize * page + 1;
            totalRows = totalRecords;
            endRow = this.getPageEnd(startRow, totalRows);
        }
        else if(sortedData.length > 0) {
            startRow = pageSize * page + 1;
            totalRows = sortedData.length;
            endRow = this.getPageEnd(startRow, totalRows);
        } 

        var startRowString = startRow.toLocaleString();
        var totalRowsString = totalRows.toLocaleString();
        var endRowString = endRow.toLocaleString();

        return (
            <div
                className='-pagination'
                style={this.props.paginationStyle}
            >
                <div className='-previous'>
                    <PreviousComponent
                        onClick={e => 
                            {
                                if (!canPrevious) return
                                this.changePage(page - 1)
                            }
                        }
                        disabled={!canPrevious}
                    >
                        <span className="-btn ui-icon ui-icon-seek-prev"></span>
                    </PreviousComponent>
                    <PreviousComponent
                        onClick={e => 
                            {
                                if (!canPrevious) return
                                this.changePage(0)
                            }
                        }
                        disabled={!canPrevious}
                    >
                        <span className="-btn ui-icon ui-icon-seek-first"></span>
                    </PreviousComponent>
                </div>
                <div className='-center'>
                    <span className='-pageInfo'>
                        {this.props.pageText}{' '}
                        {showPageJump
                        ? <div className='-pageJump'>
                            <input
                                type={this.state.page === '' ? 'text' : 'number'}
                                onChange={e => 
                                    {
                                        const val = e.target.value
                                        const page = val - 1
                                        if (val === '') {
                                            return this.setState({ page: val })
                                        }
                                        this.setState({ page: this.getSafePage(page) })
                                    }
                                }
                                value={this.state.page === '' ? '' : this.state.page + 1}
                                onBlur={this.applyPage}
                                onKeyPress={e => 
                                    {
                                        if (e.which === 13 || e.keyCode === 13) 
                                        {
                                            this.applyPage()
                                        }
                                    }
                                }
                            />
                        </div>
                        : <span className='-currentPage'>
                            {page + 1}
                        </span>}
                        {' '}
                        {this.props.ofText}
                        {' '}
                        <span className='-totalPages'>
                            {pages || 1}
                        </span>
                    </span>
                    {showPageSizeOptions &&
                        <span className='select-wrap -pageSizeOptions'>
                            <select
                                onChange={e => onPageSizeChange(Number(e.target.value))}
                                value={pageSize}
                            >
                                {
                                    pageSizeOptions.map((option, i) => {
                                        return (
                                            <option key={i} value={option}>
                                                {option} {this.props.rowsText}
                                            </option>
                                        )}
                                    )
                                }
                            </select>
                        </span>
                    }
                </div>
                <div className='-next'>
                    <NextComponent
                        onClick={e => {
                            if (!canNext) return
                                this.changePage(page + 1)
                            }}
                        disabled={!canNext}
                    >
                        <span className="-btn ui-icon ui-icon-seek-next"></span>
                    </NextComponent>
                    <NextComponent
                        onClick={e => {
                            if (!canNext) return
                                this.changePage(pages)
                            }}
                        disabled={!canNext}
                    >
                        <span className="-btn ui-icon ui-icon-seek-end"></span>
                    </NextComponent>
                </div>
                <div className="viewRecords">
                    View {startRowString} - {endRowString} of {totalRowsString}
                </div>
            </div>
        );
    }
}


/////////////////////////////////////////////
/////// Custom Plain React Table component
/////////////////////////////////////////////
export class PlainCFTable extends React.Component {
    constructor(props){
        super(props);

        var { data, columns } = this.props;

        this.renderReactTable = this.renderReactTable.bind(this);
    }

    renderReactTable() {
        var { columns, filterable, sortable, resizable, data, defaultSortAsc, defaultSortAccessor } = this.props;

        var _this = this;

        var dataArray = data;

        var columns = _generateTableColumns(columns, [], data.length);

        var className = "cf-plaintable" + (this.props.className ? ' ' + this.props.className : '');

        var defaultSorted = [];

        if(defaultSortAsc != null && defaultSortAccessor != null){
            defaultSorted = [
                {
                    desc: defaultSortAsc,
                    id: defaultSortAccessor
                }
            ];
        };

        return (
            <ReactTable
                data={dataArray}
                columns={columns}
                className={className}
                filterable={filterable}
                sortable={sortable}
                resizable={resizable}
                defaultSorted={defaultSorted}
                defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value}
                showPageSizeOptions={false}
                showPageJump={false}
                defaultPageSize={this.props.pageSize}
                minRows={1}
                showPagination={false}
                SubComponent={this.props.errorWell}
                expanded={this.props.errorsShown}
            />
        )
    }

    render() {
        var table = this.renderReactTable();

        return (
            <div className='field_row'>
                { table }
                { this.props.showResultCount === true && this.props.data ? 
                    <div className='cf_plaintable_result_count'>{this.props.data.length} Results Found</div>
                    : ''
                }
            </div>
        );
    }
};




// WEBPACK FOOTER //
// ./src/table/common-react-table.js